/* eslint-disable no-unused-vars */
import { Outlet } from "react-router-dom";
import "./common.css";
import SideMenu from "./SideMenu";
import { Drawer } from "rsuite";
import { useEffect, useState } from "react";

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const SelectedNav = (item) => {
    setMenuOpen(false);
  };

  return (
    <div className="container-fluid layoutContainer">
      <div className="d-flex flex-row h-100 w-100">
        {isMobile ? (
          <>
            <div>
              {/* Drawer for mobile */}
              <Drawer
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
                placement="left"
                backdrop={true}
                size="xs"
                enforceFocus={true}
              >
                <Drawer.Body>
                  <div className="sideMenuBg">
                    <SideMenu ClickItem={SelectedNav} />
                  </div>
                </Drawer.Body>
              </Drawer>
            </div>
          </>
        ) : (
          <div className="sideMenuBg">
            <SideMenu ClickItem={SelectedNav} />
          </div>
        )}
        <div className="w-100 pl-10 bgColor">
          <Outlet context={{ menuOpen, setMenuOpen, isMobile }} />
        </div>
      </div>
    </div>
  );
}
export default Layout;
